import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortModalService {

  private selectedPortSubject = new BehaviorSubject<any>(null);
  public selectedPort$ = this.selectedPortSubject.asObservable();

  constructor() { }

  setSelectedPort(port: any): void {
    this.selectedPortSubject.next(port);
  }

  getSelectedPort(): any | null {
    return this.selectedPortSubject.value;
  }

  clearSelectedPort(): void {
    this.selectedPortSubject.next(null);
  }
}
